/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useState } from "react";
import { ResourceDetailsResourceGroupsTable } from "./ResourceDetailsResourceGroupsTable";
import { ResourceDetailsResourceGroupsTableHeader } from "./ResourceDetailsResourceGroupsTableHeader";

type Props = {
  resourceId: string;
  resourceName: string;
};

export function ResourceDetailsResourceGroupsTab({
  resourceId,
  resourceName,
}: Props) {
  const [resultsCount, setResultsCount] = useState(0);

  return (
    <>
      <ResourceDetailsResourceGroupsTableHeader resultsCount={resultsCount} />
      <ResourceDetailsResourceGroupsTable
        resourceId={resourceId}
        resourceName={resourceName}
        onCountChange={setResultsCount}
      />
    </>
  );
}
